import { defineStore } from 'pinia';

export const useAppStore = defineStore('appstore', {
	state: () => ({
		leftDrawer: true,
		leftDrawerMini: false,
		rightDrawer: {
			showDrawer: false,
			pageComponent: '',
			pageUrl: '',
			pageData: null,
			rightDrawerWidth: 400,
			onClose: null,
		},
		pageErrors: [],
		pageDialog: {
			showDialog: false,
			pageComponent: '',
			pageUrl: '',
			pageData: null,
			props: {},
			seamless: false,
			position: 'standard',
			persistent: false,
			maximized: false,
			closeBtn: false,
			width: '700px',
			width: '95vw',
		},
		imageDialog: {
			showDialog: false,
			currentSlide: 1,
			images: [],
		},
		pdfDialog: {
			showDialog: false,
			filePath: null,
		},
		reportDialog: {
			showDialog: false,
			title: '',
			pdfBlob: null,
			downloadFileName: '',
		},
		fullScreenLoading: false,
		fullScreenLoadingMsg: null,
	}),
	getters: {
		isDialogOpen(state) {
			return (state.pageDialog.showDialog || state.rightDrawer.showDrawer || state.reportDialog.showDialog)
		},
	},
	actions: {
		openFullScreenLoading(value){
			this.fullScreenLoading = true;
			this.fullScreenLoadingMsg = value;
		},
		openPageDrawer(payload) {
			this.rightDrawer.width = payload.width || 400;
			this.rightDrawer.pageComponent = payload.page;
			this.rightDrawer.pageUrl = payload.url;
			this.rightDrawer.pageData = payload.pageData;
			this.rightDrawer.onClose = payload.onClose || null;
			this.rightDrawer.showDrawer = true;
		},
		openPageDialog(payload) {
			this.pageDialog.pageComponent = payload.page;
			this.pageDialog.pageUrl = payload.url;
			this.pageDialog.pageData = payload.pageData;
			this.pageDialog.props = payload.props;

			this.pageDialog.seamless = payload.seamless || false;
			this.pageDialog.persistent = payload.persistent || false;
			this.pageDialog.position = payload.position || 'center';
			this.pageDialog.maximized = payload.maximized || false;
			this.pageDialog.closeBtn = payload.closeBtn || false;
			if (payload.maximized) {
				this.pageDialog.width = payload.width || '';
				this.pageDialog.maxWidth = '';
			}
			else {
				this.pageDialog.width = payload.width || '700px';
				this.pageDialog.maxWidth = '95vw';
			}
			this.pageDialog.showDialog = true;
		},
		openImageDialog(payload) {
			// Defensive: normalize images to an array of non-empty strings
			let imgs = payload && payload.images !== undefined ? payload.images : [];
			if (!Array.isArray(imgs)) imgs = [imgs];
			imgs = imgs
				.flat()
				.filter(i => i !== null && i !== undefined && i !== '')
				.map(i => (typeof i === 'string' ? i : (i && i.toString ? i.toString() : '')));
			this.imageDialog.images = imgs;
			// Normalize currentSlide to a safe 0-based index
			let slide = 0;
			if (payload && payload.currentSlide !== undefined && payload.currentSlide !== null) {
				slide = Number(payload.currentSlide) || 0;
				// If callers pass 1-based slide numbers (some code uses 1), convert to 0-based
				if (slide > 0) slide = slide - 1;
			}
			if (slide < 0) slide = 0;
			if (imgs.length === 0) slide = 0;
			if (slide >= imgs.length) slide = Math.max(0, imgs.length - 1);
			this.imageDialog.currentSlide = slide;
			this.imageDialog.showDialog = true;
		},
		openPdfDialog(filePath) {
			this.pdfDialog.filePath = filePath;
			this.pdfDialog.showDialog = true;
		},
		openReportDialog(payload) {
			this.reportDialog.title = payload.title || '';
			this.reportDialog.pdfBlob = payload.pdfBlob;
			this.reportDialog.downloadFileName = payload.downloadFileName || 'report.pdf';
			this.reportDialog.showDialog = true;
		},
		closeDialogs() {
			// Execute onClose callback for drawer if provided
			if (this.rightDrawer.showDrawer && this.rightDrawer.onClose && typeof this.rightDrawer.onClose === 'function') {
				this.rightDrawer.onClose();
			}
			this.pageDialog.showDialog = false;
			this.imageDialog.showDialog = false;
			this.rightDrawer.showDrawer = false;
			this.rightDrawer.onClose = null;
			this.fullScreenLoading = false;
			this.pdfDialog.showDialog = false;
			this.reportDialog.showDialog = false;
		},
		closePageDialog() {
			this.pageDialog.showDialog = false;
		},
		closeImageDialog() {
			this.imageDialog.showDialog = false;
		},
		closePdfDialog() {
			this.pdfDialog.showDialog = false;
		},
		closeReportDialog() {
			this.reportDialog.showDialog = false;
			// Cleanup will be handled by the component
			this.reportDialog.pdfBlob = null;
		},
		closeRightDrawer() {
			// Execute onClose callback if provided
			if (this.rightDrawer.onClose && typeof this.rightDrawer.onClose === 'function') {
				this.rightDrawer.onClose();
			}
			this.rightDrawer.showDrawer = false;
			this.rightDrawer.onClose = null;
		},
		closeFullScreenLoading() {
			this.fullScreenLoading = false;
		},
		showPageErrors(errors) {
			this.pageErrors = errors;
		},
	},
});
